import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import BellIcon from 'mdi-react/BellOutlineIcon';

export const AlertSettings = styled.div`
  padding: ${layout.spacing.xSmall};
`;

export const AlertIcon = styled(BellIcon).attrs(p => ({
  color: p.theme.icons.quaternary,
}))``;
